export const NEW_PATIENT_RETRACK_ATTACHMENT = 'NEW_PATIENT_RETRACK_ATTACHMENT';
export const NEW_PATIENT_TEETH_INCLUDED_GAP = 'NEW_PATIENT_TEETH_INCLUDED_GAP';
export const NEW_PATIENT_INFO_CHANGE_TP_OPTS = 'NEW_PATIENT_INFO_CHANGE_TP_OPTS';
export const NEW_PATIENT_ENABLE_RAY_CHOOSE_3dFILE = 'NEW_PATIENT_ENABLE_RAY_CHOOSE_3dFILE';
export const NEW_PATIENT_3dFILE_CHOOSED = 'NEW_PATIENT_3dFILE_CHOOSED';
export const NEW_PATIENT_FACIAL_SCAN = 'NEW_PATIENT_FACIAL_SCAN';
export const NEW_PATIENT_DELIVERY_PROMO = 'NEW_PATIENT_DELIVERY_PROMO';
export const NEW_PATIENT_DELIVERY_ADDRESS = 'NEW_PATIENT_DELIVERY_ADDRESS';

export const NEW_PATIENT_INFO_GENDER = 'NEW_PATIENT_INFO_GENDER';
export const NEW_PATIENT_INFO_LASTNAME = 'NEW_PATIENT_INFO_LASTNAME';
export const NEW_PATIENT_INFO_FIRSTNAME = 'NEW_PATIENT_INFO';
export const NEW_PATIENT_INFO_DAY = 'NEW_PATIENT_INFO_DAY';
export const NEW_PATIENT_INFO_MONTH = 'NEW_PATIENT_INFO_MONTH';
export const NEW_PATIENT_INFO_YEAR = 'NEW_PATIENT_INFO_YEAR';
export const NEW_PATIENT_INFO_REFERENCE_CODE = 'NEW_PATIENT_INFO_REFERENCE_CODE';
export const NEW_PATIENT_INFO_REMARK = 'NEW_PATIENT_INFO_REMARK';
export const NEW_PATIENT_INTERNAL_REMARK = 'NEW_PATIENT_INTERNAL_REMARK';
export const NEW_PATIENT_DR_REMARK = 'NEW_PATIENT_DR_REMARK';
export const NEW_PATIENT_INFO_PHOTO = 'NEW_PATIENT_INFO_PHOTO';

export const NEW_PATIENT_QUES_EXTRACTION = 'NEW_PATIENT_QUES_EXTRACTION';
export const NEW_PATIENT_QUES_EXPANSION = 'NEW_PATIENT_QUES_EXPANSION';
export const NEW_PATIENT_QUES_EXTRACTION_CONCAT = 'NEW_PATIENT_QUES_EXTRACTION_CONCAT';
export const NEW_PATIENT_QUES_EXPANSION_CONCAT = 'NEW_PATIENT_QUES_EXPANSION_CONCAT';
export const NEW_PATIENT_QUES_INTER = 'NEW_PATIENT_QUES_INTER';
export const NEW_PATIENT_QUES_DIST = 'NEW_PATIENT_QUES_DIST';
export const NEW_PATIENT_QUES_PROCLINATION = 'NEW_PATIENT_QUES_PROCLINATION';
export const NEW_PATIENT_QUES_SIMULTAE = 'NEW_PATIENT_QUES_SIMULTAE';
export const NEW_PATIENT_QUES_JET = 'NEW_PATIENT_QUES_JET';
export const NEW_PATIENT_QUES_BITE = 'NEW_PATIENT_QUES_BITE';
export const NEW_PATIENT_QUES_MID = 'NEW_PATIENT_QUES_MID';
export const NEW_PATIENT_QUES_ACROSS = 'NEW_PATIENT_QUES_ACROSS';
export const NEW_PATIENT_QUES_TEETH = 'NEW_PATIENT_QUES_TEETH';
export const NEW_PATIENT_QUES_COMMENT = 'NEW_PATIENT_QUES_COMMENT';
export const NEW_PATIENT_CLINICAL_CONDITION_COMMENT = 'NEW_PATIENT_CLINICAL_CONDITION_COMMENT';

export const NEW_PATIENT_FILES = 'NEW_PATIENT_FILES';
export const NEW_PATIENT_RETRACK_REPORT = 'NEW_PATIENT_RETRACK_REPORT';
export const NEW_PATIENT_FILE_SHORTCUT = 'NEW_PATIENT_FILE_SHORTCUT';
export const NEW_PATIENT_FILE_INVERT = 'NEW_PATIENT_FILE_INVERT';
export const NEW_PATIENT_FILE_CHOOSE = 'NEW_PATIENT_FILE_CHOOSE';

export const NEW_PATIENT_IMPRESSION_TYPE = 'NEW_PATIENT_IMPRESSION_TYPE';
export const NEW_PATIENT_MODERN_CODE = 'NEW_PATIENT_MODERN_CODE';
export const NEW_PATIENT_SCANNER = 'NEW_PATIENT_SCANNER';
export const NEW_PATIENT_DOCTOR = 'NEW_PATIENT_DOCTOR';
export const NEW_PATIENT_WAYBILL_NUMBER = 'NEW_PATIENT_WAYBILL_NUMBER';
export const NEW_PATIENT_COURIER_COMPANY = 'NEW_PATIENT_COURIER_COMPANY';

export const NEW_PATIENT_DATA_SAVE_SUCCESS = 'NEW_PATIENT_DATA_SAVE_SUCCESS';
export const NEW_PATIENT_DATA_SAVE_FAILURE = 'NEW_PATIENT_DATA_SAVE_FAILURE';
export const NEW_PATIENT_DATA_UPDATE_SUCCESS = 'NEW_PATIENT_DATA_UPDATE_SUCCESS';
export const NEW_PATIENT_DATA_UPDATE_FAILURE = 'NEW_PATIENT_DATA_UPDATE_FAILURE';

export const NEW_PATIENT_TEMP_SAVE_SUCCESS = 'NEW_PATIENT_TEMP_SAVE_SUCCESS';
export const NEW_PATIENT_INIT_TEMP = 'NEW_PATIENT_INIT_TEMP';
export const NEW_PATIENT_INIT_DRAFT_FILE = 'NEW_PATIENT_INIT_DRAFT_FILE';

export const NEW_PATIENT_FILE_ROTATE = 'NEW_PATIENT_FILE_ROTATE';
export const NEW_PATIENT_INFO_PHOTO_ROTATE = 'NEW_PATIENT_INFO_PHOTO_ROTATE';

export const CHANGE_CLINICAL_CONDITION = 'CHANGE_CLINICAL_CONDITION';
export const NEW_PATIENT_DATA_ERROR = 'NEW_PATIENT_DATA_ERROR';

export const NEW_PATIENT_CBCT = 'NEW_PATIENT_CBCT';
export const NEW_PATIENT_REMOVE_CBCT = 'NEW_PATIENT_REMOVE_CBCT';

export const NEW_PATIENT_PRES_ARCH_PAT_STEP = 'NEW_PATIENT_PRES_ARCH_PAT_STEP';
export const NEW_PATIENT_PRES_ARCH_TO_TREAT = 'NEW_PATIENT_PRES_ARCH_TO_TREAT';
export const NEW_PATIENT_PRES_NOT_TO_TREAT = 'NEW_PATIENT_PRES_NOT_TO_TREAT';
export const NEW_PATIENT_PRES_ATTACHMENTS = 'NEW_PATIENT_PRES_ATTACHMENTS';
export const NEW_PATIENT_PRES_ATTACHMENTS_PLACE = 'NEW_PATIENT_PRES_ATTACHMENTS_PLACE';
export const NEW_PATIENT_PRES_ATTACHMENTS_NOT_PLACE = 'NEW_PATIENT_PRES_ATTACHMENTS_NOT_PLACE';
export const NEW_PATIENT_PRES_ATTACHMENTS_DELAY = 'NEW_PATIENT_PRES_ATTACHMENTS_DELAY';
export const NEW_PATIENT_PRES_ATTACHMENTS_DELAY_STAGE = 'NEW_PATIENT_PRES_ATTACHMENTS_DELAY_STAGE';
export const NEW_PATIENT_PRES_MARGIN_PLACEMENT = 'NEW_PATIENT_PRES_MARGIN_PLACEMENT';
export const NEW_PATIENT_PRES_AP_RELATIONSHIPS = 'NEW_PATIENT_PRES_AP_RELATIONSHIPS';
export const NEW_PATIENT_PRES_SPACING = 'NEW_PATIENT_PRES_SPACING';
export const NEW_PATIENT_PRES_SPACING_LOCATION = 'NEW_PATIENT_PRES_SPACING_LOCATION';
export const NEW_PATIENT_PRES_CROWDING = 'NEW_PATIENT_PRES_CROWDING';
export const NEW_PATIENT_PRES_CROWDING_TEETH = 'NEW_PATIENT_PRES_CROWDING_TEETH';
export const NEW_PATIENT_PRES_OVERJET = 'NEW_PATIENT_PRES_OVERJET';
export const NEW_PATIENT_PRES_OPEN_BITE = 'NEW_PATIENT_PRES_OPEN_BITE';
export const NEW_PATIENT_PRES_OPEN_BITE_IMPROVE = 'NEW_PATIENT_PRES_OPEN_BITE_IMPROVE';
export const NEW_PATIENT_PRES_OPEN_BITE_CHECKBOX = 'NEW_PATIENT_PRES_OPEN_BITE_CHECKBOX';
export const NEW_PATIENT_PRES_OPEN_BITE_TEXT = 'NEW_PATIENT_PRES_OPEN_BITE_TEXT';
export const NEW_PATIENT_PRES_DEEP_BITE = 'NEW_PATIENT_PRES_DEEP_BITE';
export const NEW_PATIENT_PRES_DEEP_BITE_IMPROVE = 'NEW_PATIENT_PRES_DEEP_BITE_IMPROVE';
export const NEW_PATIENT_PRES_DEEP_BITE_CHECKBOX = 'NEW_PATIENT_PRES_DEEP_BITE_CHECKBOX';
export const NEW_PATIENT_PRES_DEEP_BITE_TEXT = 'NEW_PATIENT_PRES_DEEP_BITE_TEXT';
export const NEW_PATIENT_PRES_MIDLINE = 'NEW_PATIENT_PRES_MIDLINE';
export const NEW_PATIENT_PRES_MIDLINE_IMPROVE = 'NEW_PATIENT_PRES_MIDLINE_IMPROVE';
export const NEW_PATIENT_PRES_MIDLINE_POSITION = 'NEW_PATIENT_PRES_MIDLINE_POSITION';
export const NEW_PATIENT_PRES_POSTERIOR_CROSSBITE = 'NEW_PATIENT_PRES_POSTERIOR_CROSSBITE';
export const NEW_PATIENT_PRES_POSTERIOR_CROSSBITE_CORRECT = 'NEW_PATIENT_PRES_POSTERIOR_CROSSBITE_CORRECT';
export const NEW_PATIENT_PRES_POSTERIOR_CROSSBITE_TEETH = 'NEW_PATIENT_PRES_POSTERIOR_CROSSBITE_TEETH';
export const NEW_PATIENT_PRES_POSTERIOR_CROSSBITE_OTHER = 'NEW_PATIENT_PRES_POSTERIOR_CROSSBITE_OTHER';
export const NEW_PATIENT_PRES_CUTTING_OPTIONS = 'NEW_PATIENT_PRES_CUTTING_OPTIONS';
export const NEW_PATIENT_PRES_AUXILIARIES = 'NEW_PATIENT_PRES_AUXILIARIES';
export const NEW_PATIENT_PRES_AUXILIARIES1 = 'NEW_PATIENT_PRES_AUXILIARIES1';
export const NEW_PATIENT_PRES_AUXILIARIES_OTHER_ELASTICS = 'NEW_PATIENT_PRES_AUXILIARIES_OTHER_ELASTICS';
export const NEW_PATIENT_PRES_DIM_FORCE = 'NEW_PATIENT_PRES_DIM_FORCE';
export const NEW_PATIENT_PRES_DIM_FORCE_CLICK_PLACE = 'NEW_PATIENT_PRES_DIM_FORCE_CLICK_PLACE';
export const NEW_PATIENT_PRES_SPECIAL_INSTRUCTIONS = 'NEW_PATIENT_PRES_SPECIAL_INSTRUCTIONS';

export const NEW_PATIENT_PRES_TRIODIM_FORCE = 'NEW_PATIENT_PRES_TRIODIM_FORCE';

export const NEW_PATIENT_PRES_ERROR = 'NEW_PATIENT_PRES_ERROR';
export const NEW_PATIENT_PRES_ERROR_QUESTION = 'NEW_PATIENT_PRES_ERROR_QUESTION';
export const NEW_PATIENT_PRES_ERROR_SCROLL_ID = 'NEW_PATIENT_PRES_ERROR_SCROLL_ID';
export const NEW_PATIENT_PRES_ERROR_SCROLL = 'NEW_PATIENT_PRES_ERROR_SCROLL';

export const NEW_PATIENT_RESET_RETAINER_REQUEST = 'NEW_PATIENT_RESET_RETAINER_REQUEST';

// set for Reset initial state

export const NEW_PATIENT_INFO_RESET_GENDER = 'NEW_PATIENT_INFO_RESET_GENDER';
export const NEW_PATIENT_INFO_RESET_LASTNAME = 'NEW_PATIENT_INFO_RESET_LASTNAME';
export const NEW_PATIENT_INFO_RESET_FIRSTNAME = 'NEW_PATIENT_INFO_RESET_FIRSTNAME';
export const NEW_PATIENT_INFO_RESET_DAY = 'NEW_PATIENT_INFO_RESET_DAY';
export const NEW_PATIENT_INFO_RESET_MONTH = 'NEW_PATIENT_INFO_RESET_MONTH';
export const NEW_PATIENT_INFO_RESET_YEAR = 'NEW_PATIENT_INFO_RESET_YEAR';
export const NEW_PATIENT_INFO_RESET_REFERENCE_CODE = 'NEW_PATIENT_INFO_RESET_REFERENCE_CODE';
export const NEW_PATIENT_INFO_RESET_REMARK = 'NEW_PATIENT_INFO_RESET_REMARK';
export const NEW_PATIENT_RESET_INTERNAL_REMARK = 'NEW_PATIENT_RESET_INTERNAL_REMARK';
export const NEW_PATIENT_RESET_DR_REMARK = 'NEW_PATIENT_RESET_DR_REMARK';
export const NEW_PATIENT_INFO_RESET_PHOTO = 'NEW_PATIENT_INFO_RESET_PHOTO';

export const NEW_PATIENT_RFS_USE_FILES = 'NEW_PATIENT_RFS_USE_FILES';

export const NEW_PATIENT_SET_RETAINER_REQUEST = 'NEW_PATIENT_SET_RETAINER_REQUEST';

export const NEW_PATIENT_RESTORATIVE_OPTIONS = 'NEW_PATIENT_RESTORATIVE_OPTIONS';

export const NEW_PATIENT_RESTORATIVE_OPTIONS_SUB_VALUE = 'NEW_PATIENT_RESTORATIVE_OPTIONS_SUB_VALUE';

export const NEW_PATIENT_RESTORATIVE_OPTIONS_ONLAY = 'NEW_PATIENT_RESTORATIVE_OPTIONS_ONLAY';

export const NEW_PATIENT_RESTORATIVE_OPTIONS_SUB_VALUE_VERTICAL_DIMENSION =
    'NEW_PATIENT_RESTORATIVE_OPTIONS_SUB_VALUE_VERTICAL_DIMENSION';

export const NEW_PATIENT_PREIMPLANT_ALIGNMENT_OPTION = 'NEW_PATIENT_PREIMPLANT_ALIGNMENT_OPTION';
export const NEW_PATIENT_PREIMPLANT_ALIGNMENT_OPTION_PROSTHETIC_SPACE =
    'NEW_PATIENT_PREIMPLANT_ALIGNMENT_OPTION_PROSTHETIC_SPACE';

export const NEW_PATIENT_ADD_ON_SMILE_DESIGN = 'NEW_PATIENT_ADD_ON_SMILE_DESIGN';

export const NEW_PATIENT_SET_UPSELL_SMILE_DESIGN_PRESCRIPTION_FORM_DATA =
    'NEW_PATIENT_SET_UPSELL_SMILE_DESIGN_PRESCRIPTION_FORM_DATA';
export const NEW_PATIENT_SET_UPSELL_SMILE_DESIGN_PRESCRIPTION_FORM_IS_VALID =
    'NEW_PATIENT_SET_UPSELL_SMILE_DESIGN_PRESCRIPTION_FORM_IS_VALID';

export const NEW_PATIENT_SET_VISITED_TABS = 'NEW_PATIENT_SET_VISITED_TABS';

export const NEW_PATIENT_SET_RESTORATIVE_OPTION_DELIVERY = 'NEW_PATIENT_SET_RESTORATIVE_OPTION_DELIVERY';

export const NEW_PATIENT_RESTORATIVE_OPTIONS_POSTERIOR = 'NEW_PATIENT_RESTORATIVE_OPTIONS_UPPER_POSTERIOR';
